export default __webpack_public_path__ + "static/media/navigation_black.89009538.svg";